module.exports = __webpack_public_path__ + "static/media/instagram.fc23b902.svg";